import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import faCheck from '@fortawesome/fontawesome-pro-light/faCheck';
import faTimes from '@fortawesome/fontawesome-pro-light/faTimes';
import { isEmailValid, isPhoneValid } from '../validators';
import T from './Translate';

class TextInput extends Component {

	constructor(props) {
		super(props);

		// TextInput můze být jak napojený na Redux Form (1. případ), tak NEnapojený (2. případ)
		const value = props.input ? props.input.value : (props.defaultValue || props.value || '');

		this.state = {
			focus: false,
			filled: !!value.toString().length,
			isValid: null,
		};
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.input && (this.state.filled !== !!nextProps.input.value.length)) {
			this.setState({
				filled: !!nextProps.input.value.length
			})
		}
	}

	onFocus = () => {
		if (this.props.readOnly) return;

		this.setState({
			focus: true,
		});
	};

	onBlur = (e) => {
		if (this.props.readOnly) return;

		let additionalValidityCondition = true;

		if (this.props.input.name === 'email' && !isEmailValid(e.target.value)) {
			additionalValidityCondition = false;

		} else if (this.props.input.name === 'phone' && !isPhoneValid(e.target.value)) {
			additionalValidityCondition = false;
		}

		this.setState({
			focus: false,
			filled: !!e.target.value.length,
			isValid: this.props.required ? (!!e.target.value.length && additionalValidityCondition) : null,
		});
	};

	onChange = (e) => {
		this.props.input.onChange(e.target.value);
	};

	render() {

		const {textarea, fontAwesomeIconBig} = this.props;

		const inputContainer = this.props.inputContainer !== undefined ?  this.props.inputContainer : true;

		const error = this.props.meta && this.props.meta.error ? this.props.meta.error : false;

		const attributes = {
			className: 'inp-text',
			id: this.props.id,
			placeholder: this.props.placeholder,
			onFocus: this.onFocus,
			onBlur: this.onBlur,
			disabled: this.props.disabled || false,
			readOnly: this.props.readOnly || false,
			ref: input => this.inputEl = input,
		};

		if (!textarea) {
			attributes.type = this.props.type || 'text';
			attributes.defaultValue = this.props.defaultValue;
		} else {
			attributes.className += ' large-input__textarea';
		}

		// Přidáváme, pokud se jedná o input kontrolovaný přes redux-form (poznáme podle toho, že v props se nachází input)
		if (this.props.input) {
			attributes.onChange = this.onChange;
			attributes.value = this.props.input.value;
		} else {
			attributes.value = this.props.value;
		}

		if (this.props.storeTextInputRef) {
			attributes.ref = input => this.props.storeTextInputRef(input);
		}

		if (this.props.tabIndex) {
			attributes.tabIndex = this.props.tabIndex;
		}

		if (textarea) {
			return (
				<div className="large-input-container">
					<div className={`large-input large-input--textarea ${this.state.focus ? 'large-input--focus' : ''} ${this.state.filled ? 'large-input--filled' : ''} ${this.props.className || ''}`}>
						<textarea {...attributes} />
						<label htmlFor={this.props.id}>{this.props.label}</label>
					</div>
				</div>
			);
		}

		const input = (
			<div className={`
					large-input
					${fontAwesomeIconBig ? 'large-input--with-big-icon' : ''}
					${this.state.focus ? 'large-input--focus' : ''}
					${this.state.filled ? 'large-input--filled' : ''}
					${error ? 'large-input--error' : ''}
					${this.props.className || ''}
					`}
			>
				{!!fontAwesomeIconBig &&
				<FontAwesomeIcon
					icon={fontAwesomeIconBig}
					className="large-input__big-icon"
				/>
				}

				<input {...attributes} />
				<label htmlFor={this.props.id}>{this.props.label}</label>
				{this.state.showIcon === 'valid' &&
				<div className="large-input__validity-icon">
					<FontAwesomeIcon icon={faCheck}/>
				</div>
				}
				{this.state.isValid !== null &&
				<div className={`large-input__validity-icon large-input__validity-icon--${this.state.isValid ? 'valid' : 'invalid'}`}>
					<FontAwesomeIcon icon={this.state.isValid ? faCheck : faTimes}/>
				</div>
				}
			</div>
		);

		if (inputContainer) {
			return (
				<div className="large-input-container">
					{input}
					{error && <div className="large-input-container__error"><T id={error} /></div>}
				</div>
			);
		}

		return input;
	}
}

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/TextInput.jsx